export function isCatalogIntegrationActive(job) {
    return job?.status === 'queued' || job?.status === 'running';
}
export function catalogIntegrationErrorKey(code) {
    if (code === 'shopify_admin_credentials_missing' || code === 'qrcodex_credentials_missing')
        return 'credentialsMissing';
    if (code === 'catalog_product_not_shopify_publish_ready')
        return 'notReady';
    return code
        .replace(/^catalog_integration_/, '')
        .replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}
